
import { Stack, Typography } from "@mui/material";

const NoResults = ({ Icon, title, description }) => {
    return (
        <Stack sx={{ my: 10, display: 'flex', alignItems: 'center' }}>
            {Icon && <Icon fontSize='large' sx={{ color: "primary.main" }} />}
            <Typography varian='h4' fontWeight='bold' color='primary.main'>{title}</Typography>
            <Typography textAlign='center'>{description}</Typography>
        </Stack>
    );
};

export default NoResults;